/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliLoginResponseDto } from '../../models/amoxcalli-login-response-dto';
import { AmoxcalliRefreshTokenRequestDto } from '../../models/amoxcalli-refresh-token-request-dto';

export interface ApiRefreshTokenRotatePost$Plain$Params {
      body?: AmoxcalliRefreshTokenRequestDto
}

export function apiRefreshTokenRotatePost$Plain(http: HttpClient, rootUrl: string, params?: ApiRefreshTokenRotatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliLoginResponseDto>> {
  const rb = new RequestBuilder(rootUrl, apiRefreshTokenRotatePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliLoginResponseDto>;
    })
  );
}

apiRefreshTokenRotatePost$Plain.PATH = '/api/refresh-token/rotate';
